import { createContext } from 'react';

export const BookModifiersContext = createContext({});

export default BookModifiersContext;
